import { ArrowRight, Clock3, MessageCircle, Phone, ShieldCheck } from "lucide-react";
import PublicBreadcrumbs from "../components/PublicBreadcrumbs";
import SEOHead from "../components/SEOHead";
import { CONTACT_CONFIG } from "../lib/site";
import { buildBreadcrumbSchema, buildOrganizationSchema, buildWebsiteSchema } from "../lib/seo";

const ContactPage = () => {
  const breadcrumbItems = [
    { name: "Beranda", path: "/" },
    { name: "Kontak", path: "/kontak" },
  ];

  const pageSchema = [
    buildOrganizationSchema(),
    buildWebsiteSchema(),
    buildBreadcrumbSchema(breadcrumbItems),
  ];

  return (
    <main className="pb-28 md:pb-0">
      <SEOHead
        title="Kontak Teras Alami"
        description="Hubungi tim Teras Alami melalui WhatsApp untuk informasi produk, pemesanan, dan bantuan pelanggan."
        path="/kontak"
        schema={pageSchema}
      />

      <section className="relative overflow-hidden bg-grain">
        <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
          <PublicBreadcrumbs items={breadcrumbItems} />
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-emerald-100 bg-emerald-50 px-3 py-1 text-sm font-medium text-emerald-700">
              <MessageCircle className="h-4 w-4" /> Support Teras Alami
            </span>
            <h1 className="mt-5 font-display text-4xl font-semibold leading-tight tracking-tight text-stone-900 sm:text-5xl lg:text-6xl">
              Hubungi Kami
            </h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-stone-600">
              Tim Teras Alami siap membantu Anda terkait informasi produk, pemesanan, maupun
              pertanyaan lainnya.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
        <div className="grid gap-6 lg:grid-cols-[1fr_0.9fr]">
          <div className="rounded-[2rem] border border-stone-200 bg-white p-6 shadow-sm sm:p-8">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700">
              <Phone className="h-5 w-5" />
            </span>
            <h2 className="mt-5 font-display text-2xl font-semibold text-stone-900 sm:text-3xl">
              WhatsApp Support
            </h2>
            <p className="mt-3 text-lg font-semibold text-emerald-700">
              {CONTACT_CONFIG.whatsappDisplay}
            </p>
            <p className="mt-3 text-stone-600">
              Hubungi kami untuk bertanya stok produk, bantuan pemesanan, atau informasi pengiriman.
            </p>
            <a
              href={CONTACT_CONFIG.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex h-14 items-center justify-center rounded-xl bg-emerald-600 px-6 text-base font-medium text-white transition hover:-translate-y-0.5 hover:bg-emerald-700"
            >
              Chat via WhatsApp <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </div>

          <div className="rounded-[2rem] border border-stone-200 bg-white p-6 shadow-sm sm:p-8">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-stone-100 text-stone-700">
              <Clock3 className="h-5 w-5" />
            </span>
            <h2 className="mt-5 font-display text-2xl font-semibold text-stone-900 sm:text-3xl">
              Jam Operasional
            </h2>
            <div className="mt-4 rounded-2xl border border-stone-100 bg-stone-50 p-5">
              <p className="font-semibold text-stone-900">{CONTACT_CONFIG.operationalDays}</p>
              <p className="mt-1 text-stone-600">{CONTACT_CONFIG.operationalHours}</p>
            </div>
            <p className="mt-4 text-sm leading-6 text-stone-500">
              Jam operasional dapat diubah melalui konfigurasi kontak di source frontend.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-14 sm:px-6 sm:pb-20 lg:px-8">
        <div className="rounded-[2rem] bg-gradient-to-r from-emerald-700 via-emerald-600 to-lime-600 px-6 py-8 text-white shadow-sm sm:px-8">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <span className="inline-flex items-center gap-2 text-sm font-medium text-emerald-50">
                <ShieldCheck className="h-4 w-4" /> Bantuan pelanggan
              </span>
              <h2 className="mt-2 font-display text-2xl font-semibold">
                Butuh Bantuan? Hubungi Kami Sekarang
              </h2>
            </div>
            <a
              href={CONTACT_CONFIG.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex h-12 items-center justify-center rounded-xl bg-white px-5 text-sm font-semibold text-emerald-700 hover:bg-emerald-50"
            >
              Chat via WhatsApp
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
